<script>
export default {
    name: 'GmapRoute',
    inject: ['map', 'calcRoute'],
    props: {
        legs: {
            type: Array,
            default: () => []
        },
        color: {
            type: String,
            default: '#3c4043'
        },
        points: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        renderer: null
    }),
    watch: {
        color (val) {
            this.renderer.setOptions({
                polylineOptions: { strokeColor: val },
                suppressMarkers: true,
                preserveViewport: true
            })
        },
        points: {
            handler (points) {
                if (points.length > 1) {
                    //  Calcolo e mostro il percorso tra i vari punti
                    this.calcRoute({
                        origin: points[0].position,
                        destination: points[points.length - 1].position,
                        travelMode: this.$google.maps.TravelMode.DRIVING,
                        waypoints: points.slice(1, points.length - 1).map(point => ({
                            location: point.position,
                            stopover: true
                        }))
                    }, (response, status) => {
                        if (status === this.$google.maps.DirectionsStatus.OK) {
                            this.renderer.setDirections(response)
                            this.$emit('update:legs', response.routes[0].legs)
                        } else {
                            this.$emit('error')
                        }
                    })
                }
            },
            immediate: true
        }
    },
    mounted () {
        this.renderer = new this.$google.maps.DirectionsRenderer({
            polylineOptions: { strokeColor: this.color },
            suppressMarkers: true,
            preserveViewport: true
        })
        this.renderer.setMap(this.map)
    },
    beforeDestroy () {
        this.renderer.setMap(null)
    },
    render (h) {
        return h('div', [this.$slots.default])
    }
}
</script>
